export default __webpack_public_path__ + "static/media/Lulu_Masunga.26b95f08.png";